import { Component, OnInit } from '@angular/core';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { AdminItem } from '../../../app/models/domain/admin.item';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GetSMTPByEmailRequest } from '../../../app/models/ss-api/requests/get.smtp.by.email.request';
import { GetSMTPByEmailResponse } from '../../../app/models/ss-api/responses/get.smtp.by.email.reponse';
import { UpdateAdminRequest } from '../../../app/models/ss-api/requests/update.admin.request';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { UpdateSMTPByEmailRequest } from '../../../app/models/ss-api/requests/update.smtp.by.email.request';

@Component({
    selector: 'profile-settings',
    templateUrl: './profile.settings.component.html',
    styleUrls: ['./profile.settings.component.scss']
})

export class ProfileSettingsComponent implements OnInit {

    // VARIABLES
    IsBusy: boolean = true;
    Admin: AdminItem;
    AdminForm: FormGroup;

    SMTPSettings: GetSMTPByEmailResponse;
    SMTPForm: FormGroup;

    GoogleAuthenticatorManualEntryKey: string = "";
    GoogleAuthenticatorQR: string = "";

    constructor(private api: ssApiService, private gs: GlobalService, private sweetAlert: SweetAlertService) { }

    ngOnInit() {
        this.gs.SetPageTitle('User Profile')
        this.LoadAdmins();
        this.LoadGoogleAuthenticatorSettings();
    }

    LoadGoogleAuthenticatorSettings(){
      
        let disposable = this.api.GoogleAuthenticatorQR().subscribe(response => {
            
            console.log(response);
            disposable.unsubscribe();

            if (response.Result == false){
                this.GoogleAuthenticatorManualEntryKey = "Error: " + response.Message;
            }
            else
            {
                this.GoogleAuthenticatorManualEntryKey = response.Data.ManualEntryKey;
                this.GoogleAuthenticatorQR = response.Data.QR;            
            }
        })
        
    }

    LoadAdmins() {
        this.gs.GetAdmins().then(response => {
            this.Admin = response.filter(admin => admin.AdminID == this.gs.AdminId)[0];
            this.LoadSMTP();

            this.IsBusy = false;

            this.AdminForm = new FormGroup({
                'Email': new FormControl(this.Admin.Email, [Validators.required]),
                'FirstName': new FormControl(this.Admin.FirstName, [Validators.required]),
                'LastName': new FormControl(this.Admin.LastName, [Validators.required]),
                'Username': new FormControl(this.Admin.Username, [Validators.required]),
                'Password': new FormControl('', [Validators.required]),
                'Signature': new FormControl(this.Admin.HTMLEmailSignature, [Validators.required])
            })
        })
    }

    LoadSMTP() {
        let request: GetSMTPByEmailRequest = {
            Email: this.Admin.Email
        }
        let disposable = this.api.GetSMTPByEmail(request).subscribe(response => {
            this.SMTPSettings = response.Data ? response.Data : new GetSMTPByEmailResponse();

            this.SMTPForm = new FormGroup({
                'Name': new FormControl(this.SMTPSettings.Name, [Validators.required]),
                'Username': new FormControl(this.SMTPSettings.Username, [Validators.required]),
                'Password': new FormControl('', [Validators.required]),
                'FromEmail': new FormControl(this.SMTPSettings.FromEmail, [Validators.required]),
                'FromName': new FormControl(this.SMTPSettings.FromName, [Validators.required]),
                'Host': new FormControl(this.SMTPSettings.Host, [Validators.required]),
                'Port': new FormControl(this.SMTPSettings.Port, [Validators.required]),
                'EnableSSL': new FormControl(this.SMTPSettings.EnableSSL, [Validators.required]),
                'Enabled': new FormControl(this.SMTPSettings.Enabled, [Validators.required]),
            })
            disposable.unsubscribe();
        })
    }

    SaveAccountSettings() {
        this.IsBusy = true;
        let controls = this.AdminForm.controls;

        let request: UpdateAdminRequest = {
            AdminID: this.Admin.AdminID,
            Email: controls['Email'].value,
            FirstName: controls['FirstName'].value,
            LastName: controls['LastName'].value,
            Password: controls['Password'].value,
            Username: controls['Username'].value,
            ShortNote: '',
            HTMLEmailSignature: controls['Signature'].value
        };

        let disposable = this.api.UpdateAdmin(request).subscribe(response => {
            this.IsBusy = false;

            if (response.Result) {
                this.Admin.Email = request.Email;
                this.Admin.FirstName = request.FirstName;
                this.Admin.LastName = request.LastName;
                this.Admin.Username = request.Username;

                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Account Saved Successfully',
                    timer: 1500
                }).then(() => {
                    this.gs.UpdateAdmin(this.Admin);
                })
            } else {
                this.sweetAlert.swal({
                    type: 'Error',
                    title: 'Save Failed',
                    text: response.Message
                }).then(() => { })
            }

            disposable.unsubscribe();
        })
    }

    SaveSMTPSettings() {
        this.IsBusy = true;
        let controls = this.SMTPForm.controls;

        let request: UpdateSMTPByEmailRequest = {
            Enabled: controls['Enabled'].value ? controls['Enabled'].value : false,
            EnableSSL: controls['EnableSSL'].value ? controls['EnableSSL'].value : false,
            FromEmail: controls['FromEmail'].value,
            FromName: controls['FromName'].value,
            Host: controls['Host'].value,
            Name: controls['Name'].value,
            PlainTextPassword: controls['Password'].value,
            Port: controls['Port'].value,
            Username: controls['Username'].value
        }

        let disposable = this.api.UpdateSMTPByEmail(request).subscribe(response => {
            this.IsBusy = false;

            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'SMTP Settings Saved',
                    text: 'Settings saved successfully',
                    timer: 1500
                }).then(() => { })
            } else {
                this.sweetAlert.swal({
                    type: 'Error',
                    title: 'Save Failed',
                    text: response.Message
                }).then(() => { })
            }

            disposable.unsubscribe();
        })
    }

    TestSMTPSettings() {
        this.IsBusy = true;

        let disposable = this.api.TestSMTPSettings().subscribe(response => {
            this.IsBusy = false;

            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Success',
                    text: 'Test was successful. SMTP Settings are working.'
                }).then(() => { }, () => { })
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                }).then(() => { }, () => { })
            }

            disposable.unsubscribe();
        })
    }

}
